import { render, staticRenderFns } from "./member-benefits.vue?vue&type=template&id=77cd1e06&scoped=true&"
import script from "./member-benefits.vue?vue&type=script&lang=js&"
export * from "./member-benefits.vue?vue&type=script&lang=js&"
import style0 from "./member-benefits.vue?vue&type=style&index=0&id=77cd1e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd1e06",
  null
  
)

export default component.exports